module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('div', {
    staticClass: "history"
  }, [_c('div', {
    staticClass: "history-topBar"
  }, [_c('span', {
    staticClass: "btn-back iconfont",
    on: {
      "click": _vm.hide
    }
  }, [_vm._v("")]), _vm._v(" "), _c('span', {
    staticClass: "title"
  }, [_vm._v("历史记录")])]), _vm._v(" "), _c('div', {
    staticClass: "history-wrap"
  }, [_c('table', {
    staticClass: "his-header"
  }, [_c('tr', [_c('th', {
    staticClass: "periods",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        _vm.toggleSort()
      }
    }
  }, [_c('span', [_vm._v("期次")]), _c('span', {
    staticClass: "iconfont",
    class: {
      active: _vm.isSort
    }
  }, [_vm._v("")])]), _vm._v(" "), _c('th', {
    staticClass: "redBall"
  }, [_vm._v("红球")]), _vm._v(" "), _c('th', {
    staticClass: "blueBall"
  }, [_vm._v("篮球")])])]), _vm._v(" "), _c('div', {
    ref: "history",
    staticClass: "his-content"
  }, [_c('div', [_c('table', {
    staticClass: "his-body"
  }, _vm._l((_vm.codeList), function(item) {
    return _c('tr', [_c('td', {
      staticClass: "periods"
    }, [_vm._v(_vm._s(item.index) + "期")]), _vm._v(" "), _c('td', {
      staticClass: "redBall"
    }, [_vm._v(_vm._s(item.red))]), _vm._v(" "), _c('td', {
      staticClass: "blueBall"
    }, [_vm._v(_vm._s(item.blue))])])
  })), _vm._v(" "), _c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showLoad),
      expression: "showLoad"
    }],
    staticClass: "down-load"
  }, [_c('img', {
    staticClass: "icon-load",
    attrs: {
      "src": require("../images/loading.gif")
    }
  })])])])]), _vm._v(" "), _c('div', {
    staticClass: "history-bottomBar"
  }, [_c('span', {
    staticClass: "time-text"
  }, [_vm._v("距016期投注截止:")]), _vm._v(" "), _c('span', {
    staticClass: "time"
  }, [_vm._v("00时00分")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-31f0279c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/ssc/component/history.vue
// module id = 64
// module chunks = 0